import React, { Component } from "react";
import t from "i18n";
import { formatAmount } from "../../../../services/utils";
import { CommonLoader } from "../../../common/CommonLoader";

class PaperInscriptionsCATypeCompare extends Component {

  formatData = (data) => {
    const { startMonth, endMonth } = this.props;
    const result = { individuel: {}, fiduciare: {} };

    const filteredMonths = Object.keys(data).filter((monthKey) => {
      const [, month] = monthKey.split("-");
      const m = parseInt(month, 10);
      return m >= parseInt(startMonth, 10) && m <= parseInt(endMonth, 10);
    });

    for (const month of filteredMonths) {
      for (const siloId in data[month]) {
        const silo = data[month][siloId];
        const { silotName, individuelNbrInscrit, individuelCa, fiduciareNbrInscrit, fiduciareCa } = silo;

        // Individuel
        if (!result.individuel[silotName]) {
          result.individuel[silotName] = { individuelNbrInscrit: 0, individuelCa: 0 };
        }
        result.individuel[silotName].individuelNbrInscrit += individuelNbrInscrit;
        result.individuel[silotName].individuelCa += individuelCa;

        // Fiduciaire
        if (!result.fiduciare[silotName]) {
          result.fiduciare[silotName] = { fiduciareNbrInscrit: 0, fiduciareCa: 0 };
        }
        result.fiduciare[silotName].fiduciareNbrInscrit += fiduciareNbrInscrit;
        result.fiduciare[silotName].fiduciareCa += fiduciareCa;
      }
    }

    return result;
  };


  render() {
    const { data1, data2, handleToggleKey, visibleKeys, silotDataFetch, year } = this.props;
    const formattedData1 = this.formatData(data1);
    const formattedData2 = this.formatData(data2);

    const getTotals = (categoryData, type) => {
      let totalNbr = 0;
      let totalCa = 0;
      Object.values(categoryData).forEach((item) => {
        totalNbr += item[`${type}NbrInscrit`];
        totalCa += item[`${type}Ca`];
      });
      return { totalNbr, totalCa };
    };

    const individuelTotals1 = getTotals(formattedData1.individuel, "individuel");
    const fiduciareTotals1 = getTotals(formattedData1.fiduciare, "fiduciare");
    const individuelTotals2 = getTotals(formattedData2.individuel, "individuel");
    const fiduciareTotals2 = getTotals(formattedData2.fiduciare, "fiduciare");

    const totalNbr1 = individuelTotals1.totalNbr + fiduciareTotals1.totalNbr;
    const totalCa1 = individuelTotals1.totalCa + fiduciareTotals1.totalCa;

    const totalNbr2 = individuelTotals2.totalNbr + fiduciareTotals2.totalNbr;
    const totalCa2 = individuelTotals2.totalCa + fiduciareTotals2.totalCa;

    const { } = this.props;
    return (
      <div style={{ width: '60%', display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div style={{
          background: "#F9FAFB",
          padding: "20px",
          borderRadius: "10px",
          width: "100%",
          boxShadow: "0 2px 10px rgba(0,0,0,0.1)"
        }}>
          {silotDataFetch ? <CommonLoader containerHeight={"300px"} iconFontSize={"50px"} iconColor={"#29394D"} /> :
            (
              <React.Fragment>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "4px 0",
                    fontSize: "14px",
                    color: "#29394D",
                  }}
                >
                  <span style={{ width: "35%" }}></span>
                  <span style={{ width: "30%", textAlign: "end", opacity: 0.7 }}>{year - 1}</span>
                  <span style={{ width: "30%", textAlign: "end" }}>{year}</span>
                  <span style={{ width: "5%" }}></span>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "4px 0",
                    fontSize: "14px",
                    color: "#29394D",
                  }}
                >
                  <span style={{ width: "35%" }}></span>
                  <span style={{ width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", opacity: 0.7 }}>
                    <span style={{ width: "50%", textAlign: "start" }}>Inscription</span>
                    <span style={{ width: "50%", textAlign: "end" }}>C.A</span>
                  </span>
                  <span style={{ width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", paddingLeft: "10px" }}>
                    <span style={{ width: "50%", textAlign: "start" }}>Inscription</span>
                    <span style={{ width: "50%", textAlign: "end" }}>C.A</span>
                  </span>
                  <span style={{ width: "5%" }}></span>
                </div>

                {["individuel", "fiduciare"].map((type) => {
                  const categoryData1 = formattedData1[type];
                  const categoryData2 = formattedData2[type];
                  const totals1 = type === "individuel" ? individuelTotals1 : fiduciareTotals1;
                  const totals2 = type === "individuel" ? individuelTotals2 : fiduciareTotals2;
                  const color = type === "individuel" ? "#18A0FB" : "#F47F4D";

                  return (
                    <React.Fragment key={type}>
                      <div style={{ marginTop: "15px", opacity: visibleKeys.includes(type) ? 1 : 0.5 }}>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <div style={{ display: "flex", alignItems: "center", gap: "8px", width: "23%" }}>
                            <span style={{ width: "8px", height: "8px", borderRadius: "40%", backgroundColor: color }}></span>
                            <span style={{ fontWeight: "500", fontSize: "16px", color: "#29394D", textTransform: "capitalize" }}>{type === "individuel" ? "Individuelle" : "Fiduciaire"}</span>
                          </div>
                          {
                            (parseFloat(((((totals1.totalCa) - (totals2.totalCa)) / (totals2.totalCa)) * 100).toFixed(2))) > 0
                              ?
                              <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '12%' }}>
                                <img src="/img/icons/manage-BM/BM_plus.svg" />
                                <span className={'ml-1'} style={{ color: '#02af8e' }}>{Math.abs(parseFloat(((((totals1.totalCa) - (totals2.totalCa)) / (totals2.totalCa == 0 ? totals1.totalCa : totals2.totalCa)) * 100).toFixed(2)))}%</span>
                              </div>
                              :
                              (parseFloat(((((totals1.totalCa) - (totals2.totalCa)) / (totals2.totalCa)) * 100).toFixed(2))) < 0
                                ?
                                <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '12%' }}>
                                  <img src="/img/icons/manage-BM/BM_moins.svg" />
                                  <span className={'ml-1'} style={{ color: '#fe3745' }}>{Math.abs(parseFloat(((((totals1.totalCa) - (totals2.totalCa)) / (totals2.totalCa == 0 ? totals1.totalCa : totals2.totalCa)) * 100).toFixed(2)))}%</span>
                                </div>
                                :
                                <div style={{ width: '12%' }} />
                          }
                          <span style={{ fontWeight: "500", color: color, width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", opacity: 0.7 }}>
                            <span style={{ width: "50%", textAlign: "start" }}>
                              {totals2.totalNbr}
                            </span>
                            <span style={{ width: "50%", textAlign: "end" }}>
                              {formatAmount(totals2.totalCa)}
                            </span>
                          </span>
                          <span style={{ fontWeight: "500", color: color, width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", paddingLeft: "10px" }}>
                            <span style={{ width: "50%", textAlign: "start" }}>
                              {totals1.totalNbr}
                            </span>
                            <span style={{ width: "50%", textAlign: "end" }}>
                              {formatAmount(totals1.totalCa)}
                            </span>
                          </span>
                          <span
                            style={{ width: "5%", display: "flex", justifyContent: "center", cursor: "pointer" }}
                            onClick={() => handleToggleKey(type)}
                          >
                            {type === 'fiduciare' ? (<img src={visibleKeys.includes('fiduciare') ? "/img/icons/event-stats/eye-2.svg" : "/img/icons/event-stats/eye-1.svg"} alt="" />) : null}
                            {type === 'individuel' ? (<img src={visibleKeys.includes('individuel') ? "/img/icons/event-stats/eye-2.svg" : "/img/icons/event-stats/eye-1.svg"} alt="" />) : null}
                          </span>
                        </div>
                        <div
                          style={{
                            borderTop: "1px solid #29394D",
                            marginTop: "8px",
                            paddingTop: "8px",
                            height: "155px",
                            overflowY: "auto"
                          }}
                        >
                          {Object.entries(categoryData1)
                            .sort(([, a], [, b]) => b[`${type}NbrInscrit`] - a[`${type}NbrInscrit`])
                            .map(([siloName, values1]) => {
                              const values2 = categoryData2[siloName] || { [`${type}NbrInscrit`]: 0, [`${type}Ca`]: 0 };
                              return (
                                <div
                                  key={siloName}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    padding: "10px 0",
                                    fontSize: "14px",
                                    color: "#29394D",
                                    opacity: 1,
                                    borderBottom: "1px solid #D8DDE2",
                                  }}
                                >
                                  <span style={{ width: "23%" }}>{siloName}</span>
                                  {
                                    (parseFloat(((((values1[`${type}Ca`]) - (values2[`${type}Ca`])) / (values2[`${type}Ca`])) * 100).toFixed(2))) > 0
                                      ?
                                      <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '12%' }}>
                                        <img src="/img/icons/manage-BM/BM_plus.svg" />
                                        <span className={'ml-1'} style={{ color: '#02af8e' }}>{Math.abs(parseFloat(((((values1[`${type}Ca`]) - (values2[`${type}Ca`])) / (values2[`${type}Ca`] == 0 ? values1[`${type}Ca`] : values2[`${type}Ca`])) * 100).toFixed(2)))}%</span>
                                      </div>
                                      :
                                      (parseFloat(((((values1[`${type}Ca`]) - (values2[`${type}Ca`])) / (values2[`${type}Ca`])) * 100).toFixed(2))) < 0
                                        ?
                                        <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '12%' }}>
                                          <img src="/img/icons/manage-BM/BM_moins.svg" />
                                          <span className={'ml-1'} style={{ color: '#fe3745' }}>{Math.abs(parseFloat(((((values1[`${type}Ca`]) - (values2[`${type}Ca`])) / (values2[`${type}Ca`] == 0 ? values1[`${type}Ca`] : values2[`${type}Ca`])) * 100).toFixed(2)))}%</span>
                                        </div>
                                        :
                                        <div style={{ width: '12%' }} />
                                  }
                                  <span style={{ width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", opacity: 0.7 }}>
                                    <span style={{ width: "50%", textAlign: "start" }}>{(values2[`${type}NbrInscrit`])}</span>
                                    <span style={{ width: "50%", textAlign: "end" }}>{formatAmount(values2[`${type}Ca`])}</span>
                                  </span>
                                  <span style={{ width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", paddingLeft: "10px" }}>
                                    <span style={{ width: "50%", textAlign: "start" }}>{(values1[`${type}NbrInscrit`])}</span>
                                    <span style={{ width: "50%", textAlign: "end" }}>{formatAmount(values1[`${type}Ca`])}</span>
                                  </span>
                                  <span style={{ width: "5%" }}></span>
                                </div>
                              );
                            })}
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}

                <div
                  style={{
                    borderTop: "1px solid #29394D",
                    marginTop: "25px",
                    paddingTop: "12px",
                    fontWeight: "700",
                    color: "#29394D",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "16px",
                  }}
                >
                  <span style={{ width: "23%" }}>Total</span>
                  {
                    (parseFloat(((((totalCa1) - (totalCa2)) / (totalCa2)) * 100).toFixed(2))) > 0
                      ?
                      <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '12%' }}>
                        <img src="/img/icons/manage-BM/BM_plus.svg" />
                        <span className={'ml-1'} style={{ color: '#02af8e' }}>{Math.abs(parseFloat(((((totalCa1) - (totalCa2)) / (totalCa2 == 0 ? totalCa1 : totalCa2)) * 100).toFixed(2)))}%</span>
                      </div>
                      :
                      (parseFloat(((((totalCa1) - (totalCa2)) / (totalCa2)) * 100).toFixed(2))) < 0
                        ?
                        <div style={{ display: "flex", alignItems: "baseline", gap: "5px", paddingLeft: '5px', width: '12%' }}>
                          <img src="/img/icons/manage-BM/BM_moins.svg" />
                          <span className={'ml-1'} style={{ color: '#fe3745' }}>{Math.abs(parseFloat(((((totalCa1) - (totalCa2)) / (totalCa2 == 0 ? totalCa1 : totalCa2)) * 100).toFixed(2)))}%</span>
                        </div>
                        :
                        <div style={{ width: '12%' }} />
                  }
                  <span style={{ width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", opacity: 0.7 }}>
                    <span style={{ width: "50%", textAlign: "start" }}>{totalNbr2}</span>
                    <span style={{ width: "50%", textAlign: "end" }}>{formatAmount(totalCa2)}</span>
                  </span>
                  <span style={{ width: "30%", textAlign: "end", display: "flex", justifyContent: "space-between", paddingLeft: "20px" }}>
                    <span style={{ width: "50%", textAlign: "start" }}>{totalNbr1}</span>
                    <span style={{ width: "50%", textAlign: "end" }}>{formatAmount(totalCa1)}</span>
                  </span>
                  <span style={{ width: "5%" }}></span>
                </div>
              </React.Fragment>
            )}
        </div>
      </div>
    );
  }
}

export default PaperInscriptionsCATypeCompare;



// WEBPACK FOOTER //
// ./app/components/Admin/EventStats/EventRegistrantLinechart/PaperInscriptionsCATypeCompare.js